import React from 'react';

import ImageBlurFallback from '../../Components/ImageBlurFallback';
import Heading from '../../Components/Heading';

import GURANTEE_PNG from '../../Assets/v2/ThreeHundred/Gurantee.png';
import GURANTEE_WEBP from '../../Assets/v2/ThreeHundred/Gurantee.webp';
import GURANTEE_FALLBACK from '../../Assets/fallbacks/ThreeHundred/Gurantee.jpg';

const Gurantee = () => {
  return (
    <div className="th-gurantee-container">
      <Heading
        className="th-gurantee-heading"
        title="GUARANTEED PLACEMENT WITHIN 6 MONTHS"
      />
      <ImageBlurFallback
        className="th-gurantee-image"
        fallbackImage={GURANTEE_FALLBACK}
        webpImage={GURANTEE_WEBP}
        src={GURANTEE_PNG}
      />
    </div>
  );
};

export default Gurantee;



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/Gurantee.js